import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import Editprofile from "./tabs/edit_profile";
import Notification from "./tabs/notification";
import Loyalty from "./tabs/loyalty";
import Sponsorship from "./tabs/sponsorship";
import api from "../../api";

const Profiletabs = ({ dataprofile, profileData, setProfileData, activeTab,setActiveTab }) => {
  //const [activeTab, setActiveTab] = useState("editProfile");
  const [languageData, setLanguageData] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/profile/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    if (tab) {
      setActiveTab(tab);
    }
  }, [location]);

  const renderTabContent = () => {
    switch (activeTab) {
      case "editProfile":
        return (
          <Editprofile data={dataprofile.profile} profileData={profileData} />
        );
      case "consents":
        return <Notification profileData={profileData} setProfileData={setProfileData} />;
      case "loyalty":
        const loyaltyPrograms = dataprofile?.loyalty.programs || [];
        const loyaltyPoints = dataprofile?.loyalty_wallet?.available ?? 0;
        return (
          <Loyalty
            loyaltyprograms={loyaltyPrograms}
            loyaltyPoints={Number(loyaltyPoints)}
          />
        );
      case "sponsorship":
        const sponsorshipPrograms = dataprofile?.sponsorship.programs || [];
        const sponsorshipCode = dataprofile?.sponsorship_code;
        const loyaltyConsumptions = dataprofile?.sponsorship_wallet?.total ?? 0;
        const referrals = dataprofile?.referrals || [];
        return (
          <Sponsorship
            sponsorshipPrograms={sponsorshipPrograms}
            sponsorshipCode={sponsorshipCode}
            consumptions={loyaltyConsumptions}
            referrals={referrals}
          />
        );
      default:
        return null;
    }
  };

  if (!languageData) {
    return <div></div>;
  }
  return (
    <div className="col-xxl-9 col-xl-12 text-left">
      <div className="col-xl-12">
        <div className="card custom-card">
          <div className="card-body p-0">
            <div className="border-block-end-dashed bg-white rounded-2 p-2">
              <ul
                className="nav nav-pills nav-justified gx-3 tab-style-6 d-sm-flex d-block"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item rounded" role="presentation">
                  <button data-interaction="edit_profile_tab"
                    className={`nav-link ${
                      activeTab === "editProfile" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("editProfile")}
                  >
                    {languageData.tabs.profile}
                  </button>
                </li>
                <li className="nav-item rounded" role="presentation">
                  <button data-interaction="consents_tab"
                    className={`nav-link ${
                      activeTab === "consents" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("consents")}
                  >
                    {languageData.tabs.notifications}
                  </button>
                </li>
                <li className="nav-item rounded" role="presentation">
                  <button data-interaction="loyalty_tab"
                    className={`nav-link ${
                      activeTab === "loyalty" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("loyalty")}
                  >
                    {languageData.tabs.loyalty}
                  </button>
                </li>
                <li className="nav-item rounded" role="presentation">
                  <button data-interaction="sponsorship_tab"
                    className={`nav-link ${
                      activeTab === "sponsorship" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("sponsorship")}
                  >
                    {languageData.tabs.sponsorship}
                  </button>
                </li>
              </ul>
            </div>
            <div className="py-4 pb-0">
              <div className="tab-content" id="myTabContent">
                {renderTabContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profiletabs;
